import { useQuery } from '@apollo/client/react'
import {
  PortalBusinessDocument,
  type PortalBusinessQuery,
} from '@/graphql/generated/graphql'

export type BusinessDetail = PortalBusinessQuery['portalBusiness']

export function useBusiness(businessId: string | undefined) {
  const { data, loading, error, refetch } = useQuery(PortalBusinessDocument, {
    variables: { businessId: businessId ?? '' },
    skip: !businessId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    business: data?.portalBusiness ?? null,
    loading,
    error,
    refetch,
  }
}
